import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import MDBox from "components/MDBox";

/**
 * The "Report" dropdown the export screens sit beside their Export button.
 *
 * Both export sections render one, and they were hand-rolled copies of the same markup: same
 * label, same helper text, same native select, same responsive width, differing only in the
 * options they offer. That is exactly the drift the shared filter bar exists to prevent, so the
 * control has one definition too.
 *
 * `options` is a list of `{ value, label, disabled }`. A caller decides which reports its own
 * section can produce -- the individual sections's list is role-dependent, the consolidated
 * section offers the consolidated workbooks -- and this component only draws them.
 *
 * @since NEXT_VERSION
 */
export const ReportFormatSelect = ({ id, value, onChange, options = [], label = "Report" }) => (
  <MDBox sx={{ width: { xs: "100%", sm: "auto" } }}>
    <TextField
      select
      label={label}
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      helperText="Report type"
      SelectProps={{ native: true }}
      sx={{ width: { xs: "100%", sm: "220px" } }}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value} disabled={option.disabled}>
          {option.label}
        </option>
      ))}
    </TextField>
  </MDBox>
);

ReportFormatSelect.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    })
  ),
  label: PropTypes.string,
};

export default ReportFormatSelect;
